import { FONT, MEDIA } from "@/styles/common";
import { Flex, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { PriceProps } from "./price.type";

export const Price = ({ finalPrice }: PriceProps) => {
    const { isMobile } = MEDIA();

    return (
        <Flex w={"100%"} height="100%" alignItems="flex-end">
            <Flex
                alignItems="center"
                width="100%"
                columnGap={isMobile ? "auto" : "8px"}
                justifyContent={isMobile ? "space-between" : "flex-end"}
            >
                <CustomTotalText>객실 요금</CustomTotalText>
                <Flex alignItems="center" gap="4px">
                    <CustomTotalText>{finalPrice.toLocaleString()}</CustomTotalText>
                    <CustomTotalText>원</CustomTotalText>
                </Flex>
            </Flex>
        </Flex>
    );
};

const CustomTotalText = styled(Text)`
    ${FONT("pretendard", 16, 500)}
`;
